const formatCurrency = (num) => {
  if (!num) {
    return '';
  }

  let [int, dec] = num.toString().split('.');

  if (dec) {
    dec = dec.slice(0, 2);
  }

  int = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  if (dec) {
    int += ',' + dec;
  }

  return int;
}

export default formatCurrency;
